import React, { useEffect, useRef, useState } from 'react';
import { Route, useHistory, useLocation, withRouter } from 'react-router-dom';
import App from './App';
import Access from './pages/Access';
import Error from './pages/Error';
import Login from './pages/000/001/Login';
import NotFound from './pages/NotFound';
import Wizard from './pages/Wizard';
import ChangePassword from './pages/000/001/ChangePassword';
import { DialogTimeOut } from './components/DialogService/DialogService';
import { Toast } from 'primereact/toast';
import { loginService } from './service/AUTH/LoginService';
import { TokenGenerate } from './service/AUTH/TokenService';
import { addDays, formatDateToken } from './utilities/DateUtil';
import { dataUserSession, ipAddressSession } from './utilities/dataSession';
import ValidateService from './components/ValidateService/ValidateService';

const AppWrapper = () => {

    let location = useLocation();
    const history = useHistory();
    const [dialog, setDialog] = useState({ dialog: false, text: '' })

    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0)

        if (location.pathname && location.pathname !== '/login') {
            let count = 1800;
            const interval = setInterval(() => {
                if (count === 1) {
                    onLogOutService();
                    clearInterval(interval)

                } else {
                    count = count - 1;
                }
            }, 1000);
            return () => clearInterval(interval);
        }

    }, [location]);

    const onLogOutTimeOut = () => {
        setDialog({ dialog: false });
        history.push("/login");

    }

    const onLogOutService = async () => {

        let userSession = dataUserSession() ? dataUserSession() : "";
        let ipAddress = ipAddressSession() ? ipAddressSession() : "";

        // if(ipAddress !== '' && ipAddress !== ''){

        let token = await onTokenGenerate()

        if (token && token !== "") {

            let data = {
                browser: "",
                ipAddress: "",
                loginLogout: "O",
                sessionId: ipAddress.sessionId,
                userId: userSession.userId,
                userPassword: "",
            };

            await loginService(data, token).then(
                (res) => {
                    if (res !== undefined && res.length > 0) {
                        if (res[0].statusCode === "C") {
                            setDialog({ dialog: true, text: 'กรุณาเข้าสู่ระบบใหม่ \n เนื่องจากไม่ถูกใช้งานเป็นเวลา 30 นาที' })
                        } else if (res[0].statusCode === "E") {
                            showMessages(`${res[0].statusText}`);
                        }
                    } else {
                        showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                    }
                },
                function (err) {
                    setErrData(err)
                }
            );
        }
        // }
    };

    const onTokenGenerate = async () => {
        let token = ""
        let req = {
            apiKeyId: '',
            createBy: dataUserSession() ? dataUserSession().userId : "",
            createDt: formatDateToken(new Date(), true),
            desc: "Generate Access Token By Web Application",
            expireDt: formatDateToken(addDays(new Date(), 1), true), //dateToken, // dateToken.setDate(dateToken.getDate() + 1),
            remark: "Generate",
            role: "USER",
        }

        await TokenGenerate(req).then(
            (res) => {
                if (res != undefined) {
                    token = res
                } else {
                    showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                }
            },
            function (err) {
                setErrData(err)
            }
        );

        return token
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    switch (location.pathname) {
        case '/login':
            return <Route path="/login" component={Login} />
        case '/error':
            return <Route path="/error" component={Error} />
        case '/notfound':
            return <Route path="/notfound" component={NotFound} />
        case '/access':
            return <Route path="/access" component={Access} />
        case '/wizard':
            return <Route path="/wizard" component={Wizard} />
        case '/password':
            return <Route path="/password" component={ChangePassword} />
        default:
            return (
                <>
                    <ValidateService err={errData} setErr={setErrData} />
                    <Toast ref={toast} position="top-right" />
                    <App />
                    <DialogTimeOut
                        visible={dialog.dialog} header="แจ้งเตือน" modal
                        onHide={onLogOutTimeOut} className="p-fluid"
                        textContent={dialog.text} btnCancle={onLogOutTimeOut}
                    />
                </>
            )
    }
}

export default withRouter(AppWrapper);
